<template lang="pug">
v-layout(row justify-center)
    v-dialog(data-cy="clone-modal.dialog" :value="value" persistent max-width="620")
        v-card
            title-bar(data-cy="clone-modal.title" dark) Clone Campaign?
            v-card-text
                p Are you sure you want to clone this campaign?
                p This will copy all tasks and create new template to associate with this campaign
            v-card-actions
                v-spacer
                v-btn(data-cy="clone-modal.cancel" flat @click="handleCancelClick()") Cancel
                v-btn.primary(data-cy="clone-modal.clone" @click="handleOkClick()") Ok
</template>

<script>

import TitleBar from '@/Core/components/TitleBar';

const SHARE_TYPES = {
    PUBLIC: 2,
    PRIVATE: 3,
};

export default {
    components: {
        TitleBar,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        }
    },
    methods: {
        handleCancelClick() {
            this.$emit('close');
        },
        handleOkClick() {
            this.$emit('ok');
        }
    },
};

</script>
